type FacebookPixelTrackFn = (
	fnName: 'trackCustom',
	eventName: string,

	properties?: Record<string, unknown>
) => void;

type FacebookPixelObj = FacebookPixelTrackFn;

declare const fbq: FacebookPixelObj;

export class FacebookPixel {
	track<T extends Record<string, unknown> = Record<string, never>>(
		eventName: string,
		properties?: T
	): void {
		try {
			fbq?.('trackCustom', eventName, properties);
		} catch (e) {
			console.error(e);
		}
	}
}
